<template>
  <app-modal
      :modal-id="modalId"
      :modal-size="modalSize"
      modal-alignment="top"
      @close-modal="closeModal"
      :modal-scroll="modalScroll"
      :modal-body-class="modalBodyClass">
    <template slot="header">
      <h5 class="modal-title text-capitalize">{{ title }}</h5>
      <button type="button"
              class="close outline-none"
              data-dismiss="modal"
              aria-label="Close"
              @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
      </button>
    </template>

    <template slot="body">
      <div class="legal-content" v-html="content"></div>
    </template>
  </app-modal>
</template>

<script>
export default {
  name: 'SimpleModal',
  props: {
    title: String,
    content: String,
    modalId: {
      type: String,
      default: 'simple-modal'
    },
    modalSize: {
      default: 'lg' // Large to fit legal text
    },
    modalScroll: {
      type: Boolean,
      default: true,
    },
    modalBodyClass: {
      default: 'p-4'
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.legal-content {
  white-space: pre-wrap;
  font-family: inherit;
  background: #f8f9fa;
  padding: 15px;
  border-radius: 5px;
  max-height: 60vh;
  overflow-y: auto;
}
</style>